import _regeneratorRuntime from "@babel/runtime/regenerator";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Response = /*#__PURE__*/function () {
  /**
   * Create a new response instance.
   */
  function Response(model, config, response) {
    _classCallCheck(this, Response);

    /**
     * Entities created by Vuex ORM.
     */
    this.entities = null;
    /**
     * Whether if response data is saved to the store or not.
     */

    this.isSaved = false;
    this.model = model;
    this.config = config;
    this.response = response;
  }
  /**
   * Save response data to the store.
   */


  _createClass(Response, [{
    key: "save",
    value: function () {
      var _save = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var data, method, options;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                data = this.getDataFromResponse();

                if (this.validateData(data)) {
                  _context.next = 4;
                  break;
                }

                console.warn('[Vuex ORM Axios] The response data could not be saved to the store ' + 'because it is not an object or an array. You might want to use ' + '`dataTransformer` option to handle non-array/object response ' + 'before saving it to the store.');
                return _context.abrupt("return");

              case 4:
                method = this.config.persistBy || 'insertOrUpdate';

                if (!this.validatePersistAction(method)) {
                  console.warn('[Vuex ORM Axios] The "persistBy" option configured is not a ' + 'recognized value. Response data will be persisted by the ' + 'default `insertOrUpdate` method.');
                  method = 'insertOrUpdate';
                }

                options = this.getPersistOptions();
                _context.next = 9;
                return this.model[method](_objectSpread({
                  data: data
                }, options));

              case 9:
                this.entities = _context.sent;
                this.isSaved = true;

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function save() {
        return _save.apply(this, arguments);
      }

      return save;
    }()
    /**
     * Delete the entity record where the `delete` option is configured.
     */

  }, {
    key: "delete",
    value: function () {
      var _delete2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(this.config["delete"] === undefined)) {
                  _context2.next = 2;
                  break;
                }

                throw new Error('[Vuex ORM Axios] Could not delete records because the `delete` option is not set.');

              case 2:
                _context2.next = 4;
                return this.model["delete"](this.config["delete"]);

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function _delete() {
        return _delete2.apply(this, arguments);
      }

      return _delete;
    }()
    /**
     * Get the response data from the axios response object. If a `dataTransformer`
     * option is configured, it will be applied to the response object. If the
     * `dataKey` option is configured, it will return the data from the given
     * property within the response body.
     */

  }, {
    key: "getDataFromResponse",
    value: function getDataFromResponse() {
      if (this.config.dataTransformer) {
        return this.config.dataTransformer(this.response);
      }

      if (this.config.dataKey) {
        return this.response.data[this.config.dataKey];
      }

      return this.response.data;
    }
    /**
     * Get persist options if any set in config.
     */

  }, {
    key: "getPersistOptions",
    value: function getPersistOptions() {
      var persistOptions = this.config.persistOptions;

      if (!persistOptions || _typeof(persistOptions) !== 'object') {
        return;
      }

      return Object.keys(persistOptions).filter(this.validatePersistAction) // Filter to avoid polluting the payload.
      .reduce(function (carry, key) {
        carry[key] = persistOptions[key];
        return carry;
      }, {});
    }
    /**
     * Validate the given data to ensure the Vuex ORM persist methods accept it.
     */

  }, {
    key: "validateData",
    value: function validateData(data) {
      return data !== null && _typeof(data) === 'object';
    }
    /**
     * Validate the given string as to ensure it correlates with the available
     * Vuex ORM persist methods.
     */

  }, {
    key: "validatePersistAction",
    value: function validatePersistAction(action) {
      return ['create', 'insert', 'update', 'insertOrUpdate'].includes(action);
    }
  }]);

  return Response;
}();

var Request = /*#__PURE__*/function () {
  /**
   * Create a new api instance.
   */
  function Request(model) {
    _classCallCheck(this, Request);

    /**
     * The default config.
     */
    this.config = {
      save: true
    };
    this.model = model;
    this.registerActions();
  }
  /**
   * Get the axios client.
   */


  _createClass(Request, [{
    key: "axios",
    get: function get() {
      if (!this.model.axios) {
        throw new Error('[Vuex ORM Axios] The axios instance is not registered. Please register the axios instance to the model.');
      }

      return this.model.axios;
    }
    /**
     * Register actions from the model config.
     */

  }, {
    key: "registerActions",
    value: function registerActions() {
      var actions = this.model.apiConfig.actions;

      if (!actions) {
        return;
      }

      for (var name in actions) {
        var action = actions[name];
        typeof action === 'function' ? this.registerFunctionAction(name, action) : this.registerObjectAction(name, action);
      }
    }
    /**
     * Register the given object action.
     */

  }, {
    key: "registerObjectAction",
    value: function registerObjectAction(name, action) {
      var _this = this;

      this[name] = function (config) {
        return _this.request(_objectSpread(_objectSpread({}, action), config));
      };
    }
    /**
     * Register the given function action.
     */

  }, {
    key: "registerFunctionAction",
    value: function registerFunctionAction(name, action) {
      this[name] = action.bind(this);
    }
    /**
     * Perform a get request.
     */

  }, {
    key: "get",
    value: function get(url) {
      var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this.request(_objectSpread({
        method: 'get',
        url: url
      }, config));
    }
    /**
     * Perform a post request.
     */

  }, {
    key: "post",
    value: function post(url) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return this.request(_objectSpread({
        method: 'post',
        url: url,
        data: data
      }, config));
    }
    /**
     * Perform a put request.
     */

  }, {
    key: "put",
    value: function put(url) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return this.request(_objectSpread({
        method: 'put',
        url: url,
        data: data
      }, config));
    }
    /**
     * Perform a patch request.
     */

  }, {
    key: "patch",
    value: function patch(url) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return this.request(_objectSpread({
        method: 'patch',
        url: url,
        data: data
      }, config));
    }
    /**
     * Perform a delete request.
     */

  }, {
    key: "delete",
    value: function _delete(url) {
      var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this.request(_objectSpread({
        method: 'delete',
        url: url
      }, config));
    }
    /**
     * Perform an api request.
     */

  }, {
    key: "request",
    value: function () {
      var _request = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(config) {
        var requestConfig, axiosResponse;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                requestConfig = this.createConfig(config);
                _context3.next = 3;
                return this.axios.request(requestConfig);

              case 3:
                axiosResponse = _context3.sent;
                return _context3.abrupt("return", this.createResponse(axiosResponse, requestConfig));

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function request(_x) {
        return _request.apply(this, arguments);
      }

      return request;
    }()
    /**
     * Create a new config by merging the global config, the model config,
     * and the given config.
     */

  }, {
    key: "createConfig",
    value: function createConfig(config) {
      return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, this.config), this.model.globalApiConfig), this.model.apiConfig), config);
    }
    /**
     * Create a new response instance by applying a few initialization processes.
     * For example, it saves response data if `save` option id set to `true`.
     */

  }, {
    key: "createResponse",
    value: function () {
      var _createResponse = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(axiosResponse, config) {
        var response;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                response = new Response(this.model, config, axiosResponse);

                if (!(config["delete"] !== undefined)) {
                  _context4.next = 5;
                  break;
                }

                _context4.next = 4;
                return response["delete"]();

              case 4:
                return _context4.abrupt("return", response);

              case 5:
                _context4.t0 = config.save;

                if (!_context4.t0) {
                  _context4.next = 9;
                  break;
                }

                _context4.next = 9;
                return response.save();

              case 9:
                return _context4.abrupt("return", response);

              case 10:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function createResponse(_x2, _x3) {
        return _createResponse.apply(this, arguments);
      }

      return createResponse;
    }()
  }]);

  return Request;
}();

function Model(model, config) {
  /**
   * The api client.
   */
  model.axios = config.axios || null;
  /**
   * The global api configuration for all models.
   */

  model.globalApiConfig = config;
  /**
   * The api configuration for the model.
   */

  model.apiConfig = {};
  /**
   * Set the given api client.
   */

  model.setAxios = function (axios) {
    this.axios = axios;
  };
  /**
   * Get the api instance.
   */


  model.api = function () {
    return new Request(this);
  };
}

var VuexORMAxios = /*#__PURE__*/function () {
  /**
   * Create a new Vuex ORM Axios instance.
   */
  function VuexORMAxios(components, config) {
    _classCallCheck(this, VuexORMAxios);

    this.model = components.Model;
    this.config = config;
  }
  /**
   * Plug-in features.
   */


  _createClass(VuexORMAxios, [{
    key: "plugin",
    value: function plugin() {
      Model(this.model, this.config);
    }
  }]);

  return VuexORMAxios;
}();

var index = {
  install: function install(components, config) {
    new VuexORMAxios(components, config).plugin();
  }
};
export default index;
export { Request, Response };